import { render, staticRenderFns } from "./From.vue?vue&type=template&id=7c3fdd0e&"
import script from "./From.vue?vue&type=script&lang=ts&"
export * from "./From.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports